import { useState, useEffect, useContext } from 'react';
import "../css/Modal.css"
import UserContext from "../contexts/UserContext";
import { useNavigate } from "react-router-dom";
import Select from 'react-select';
import { scrollToTop } from "../utils/helper.js";
import FetchUtil from "../utils/FetchUtil";
import { ddStyles } from "../utils/CommonStyles.js";

let timezoneOptions = [];
let countryOptions = [];
let stateOptions = [];
let departmentTypeOptions = [];
let defCountryText = "Select Country";

function DepartmentModal({ t, companyList, companyId, department, setShow, refetch, add, modalClosed }) {
	const [states, setStates] = useState([]);
	//const [countries, setCountries] = useState([]);
	const [error, setError] = useState("");
	//const [timezones, setTimezones ] = useState([]);
	const [formErrors, setFormErrors] = useState([]);
	const [isSubmit, setIsSubmit] = useState(false);
	const userCtx = useContext(UserContext);
	const navigate = useNavigate();
	const [stateSelected, setStateSelected] = useState({ name: "stateKey", label: (department.stateName), value: (department.stateKey + "-" + department.stateCode) });
	const [countrySelected, setCountrySelected] = useState({ name: "countryCode", label: (department.countryName), value: department.countryCode });
	const [timezoneSelected, setTimezoneSelected] = useState({ name: "departmentTimeZone", label: (department.departmentTimeZone), value: department.departmentTimeZone });
	const [departmentTypeSelected, setDepartmentTypeSelected] = useState({ name: "departmentTypeKey", label: (department.departmentType), value: department.departmentTypeKey });

	const [countryLoaded, setCountryLoaded] = useState(false);
	const [stateLoaded, setStateLoaded] = useState(false);
	const [timezoneLoaded, setTimezoneLoaded] = useState(false);
	const [departmentTypeLoaded, setDepartmentTypeLoaded] = useState(false);

	const submitText = t("page.submit");
	const closeText = t("page.close");

	const initialValues = {
		companyId: companyId,
		companyName: department.companyName,
		departmentKey: department.departmentKey,
		departmentTypeKey: department.departmentTypeKey,
		departmentName: department.departmentName,
		description: department.description,
		address1: department.address1,
		address2: department.address2,
		phone: department.phone,
		zipCode: department.zipCode,
		zipExt: department.zipExt,
		city: department.city,
		stateKey: department.stateKey,
		stateCode: department.stateCode,
		countryCode: department.countryCode,
		departmentTimeZone: department.departmentTimeZone,
		geocode: department.geocode,
		latitude: department.latitude,
		longitude: department.longitude,
		updatedById: userCtx.loggedInUserId,
	};
	const [formValues, setFormValues] = useState(initialValues);

	useEffect(() => {
		fetchCountries();
		fetchStates();
		fetchTimezones();
		fetchDepartmentTypes();
		initValues();
		scrollToTop();
	}, []);

	const handleClose = (event) => {
		modalClosed();
	};
	
	function initValues() {
		if (add) {
			const selectedCompany = companyList.find(company => company.companyId == companyId);
			if (selectedCompany) {
				formValues.address1 = (selectedCompany.address1) ? selectedCompany.address1 : "";
				formValues.address2 = (selectedCompany.address2) ? selectedCompany.address2 : "";
				formValues.phone = (selectedCompany.phone) ? selectedCompany.phone : "";
				formValues.zipCode = (selectedCompany.zipCode) ? selectedCompany.zipCode : "";
				formValues.zipExt = (selectedCompany.zipExt) ? selectedCompany.zipExt : "";
				formValues.city = (selectedCompany.city) ? selectedCompany.city : "";
				formValues.stateKey = (selectedCompany.stateKey) ? selectedCompany.stateKey : "";
				formValues.countryCode = (selectedCompany.countryCode) ? selectedCompany.countryCode : "US";
				formValues.stateCode = selectedCompany.stateCode;
				formValues.departmentTimeZone = selectedCompany.companyTimeZone;
				formValues.latitude = selectedCompany.latitude;
				formValues.longitude = selectedCompany.longitude;
				setCountrySelected({ ...countrySelected, label: (selectedCompany.countryName), value: (selectedCompany.countryCode) });
				setStateSelected({ ...stateSelected, label: (selectedCompany.stateName), value: (selectedCompany.stateKey + '-' + selectedCompany.stateCode) });
				setTimezoneSelected({ ...timezoneSelected, label: (selectedCompany.companyTimeZone), value: (selectedCompany.companyTimeZone) });
			} else {
				formValues.address1 = department.address1;
				formValues.address2 = department.address2;
				formValues.phone = department.phone;
				formValues.zipCode = department.zipCode;
				formValues.zipExt = department.zipExt;
				formValues.city = department.city;
				formValues.stateKey = department.stateKey;
				formValues.countryCode = department.countryCode;
				formValues.stateCode = department.stateCode;
				formValues.departmentTimeZone = department.departmentTimeZone;
				formValues.latitude = department.latitude;
				formValues.longitude = department.longitude;
				setCountrySelected({ ...countrySelected, label: (department.countryName), value: (department.countryCode) });
				setStateSelected({ ...stateSelected, label: (department.stateName), value: (department.stateKey + '-' + department.stateCode) });
				setTimezoneSelected({ ...timezoneSelected, label: (department.departmentTimeZone), value: (department.departmentTimeZone) });
			}

		}
	}
	function setCountryValues(countryObj) {
		let countryOptionValue = {};
		countryOptions = [];
		countryOptions.push({ label: "", value: "" });
		if (countryObj && countryObj.length > 0) {
			countryObj.map((country, index) => {
				countryOptionValue.label = country.countryName;
				countryOptionValue.value = country.countryCode;
				countryOptions.push(countryOptionValue);
				countryOptionValue = {};
			});
			setCountryLoaded(true);
		}

	}
	function setStateValues(stateObj, countryCode, defDataLoad) {
		let stateValue = {};
		stateOptions = [];
		stateOptions.push({ label: "", value: "0-" });
		if (stateObj && stateObj.length > 0) {
			stateObj.map((state, index) => {
				if (state.countryCode === countryCode) {
					stateValue.label = state.name;
					stateValue.value = state.stateKey + "-" + state.stateCode;
					stateOptions.push(stateValue);
					stateValue = {};
				}

			});
			setStateLoaded(true);
			if (!defDataLoad) {
				setStateSelected({ ...stateSelected, label: "", value: "0-" });
			}

		}
	}
	function setTimezoneValues(timezoneObj) {
		let timezoneValue = {};
		timezoneOptions = [];
		timezoneOptions.push({ label: "", value: "" });
		if (timezoneObj && timezoneObj.length > 0) {
			timezoneObj.map((timezone, index) => {
				timezoneValue.label = timezone.timezone;
				timezoneValue.value = timezone.timezone;
				timezoneOptions.push(timezoneValue);
				timezoneValue = {};


			});
			setTimezoneLoaded(true);
		}
	}


	function setDepartmentTypeValues(deptTypeObj) {
		let departmentTypeValue = {};
		departmentTypeOptions = [];
		departmentTypeOptions.push({ label: "", value: "0" });
		if (deptTypeObj && deptTypeObj.length > 0) {
			deptTypeObj.map((departmentType, index) => {
				departmentTypeValue.label = departmentType.departmentType;
				departmentTypeValue.value = departmentType.departmentTypeKey;
				departmentTypeOptions.push(departmentTypeValue);
				departmentTypeValue = {};
			});
			setDepartmentTypeLoaded(true);
		}
	}

	function fetchStates() {
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ source: "web", getAll: true, countryCode: (department.countryCode ? department.countryCode : "US") }),
		};
		try {
			FetchUtil.fetchAPI("MGetAllState", "/Service/StaticHelper/GetAllState", requestOptions, getStatesSuccess, getStatesFail);
		} catch (error) {
			setError(error.message);
		}
	}

	function getStatesFail(redirect) {
		setError(t("error.getStateFailed"));
	}
	function getStatesSuccess(responseData) {
		let stateResponse;
		if (responseData) {
			stateResponse = responseData.getStateResponse;
			if (stateResponse && stateResponse.errorCode === "0") {
				setStateValues(stateResponse.states, formValues.countryCode, true);
				setStates([...states, ...stateResponse.states]);
			} else if (stateResponse) {
				setError(t("error.error") + " " + stateResponse.errorMessage);
			}
		}
	}
	function fetchCountries() {
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ source: "web" }),
		};
		try {
			FetchUtil.fetchAPI("MGetCountries", "/Service/StaticHelper/GetCountries", requestOptions, getCountriesSuccess, getCountriesFail);
		} catch (error) {
			setError(error.message);
		}
	}

	function getCountriesFail(redirect) {
		setError(t("error.getCountryFailed"));
	}
	function getCountriesSuccess(responseData) {
		let countriesResponse;
		if (responseData) {
			countriesResponse = responseData.getCountriesResponse;
			if (countriesResponse && countriesResponse.errorCode === "0") {
				//setCountries([...countries, ...countriesResponse.countries]);
				setCountryValues(countriesResponse.countries);
			} else if (countriesResponse) {
				setError(t("error.error") + " " + countriesResponse.errorMessage);
			}
		}
	}

	function fetchTimezones() {
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ source: "web", getAll: false }),
		};
		try {
			FetchUtil.fetchAPI("MGetTimeZone", "/Service/StaticHelper/GetTimeZones", requestOptions, getTimezonesSuccess, getTimezonesFail);
		} catch (error) {
			setError(error.message);
		}
	}

	function getTimezonesFail(redirect) {
		if (redirect) {
			navigate("/");
		}
		setError(t("error.getTimezoneFailed"));
	}

	function getTimezonesSuccess(responseData) {
		let timezoneResponse;
		if (responseData) {
			timezoneResponse = responseData.getTimeZoneResponse;
			if (timezoneResponse && timezoneResponse.errorCode === "0") {
				//setTimezones([...timezones, ...timezoneResponse.timeZones]);
				setTimezoneValues(timezoneResponse.timeZones);
			} else if (timezoneResponse) {
				setError(t("error.error") + " " + timezoneResponse.errorMessage);
			}
		}
	}

	function fetchDepartmentTypes() {
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ source: "web", getAll: false }),
		};
		try {
			FetchUtil.fetchAPI("MGetDepartmentTypes", "/Service/StaticHelper/GetDepartmentTypes", requestOptions, getDepartmentTypesSuccess, getDepartmentTypesFail);
		} catch (error) {
			setError(error.message);
		}
	}

	function getDepartmentTypesFail(redirect) {
		if (redirect) {
			navigate("/");
		}
		setError(t("error.getDeptTypeFailed"));
	}

	function getDepartmentTypesSuccess(responseData) {
		let getDepartmentTypesResponse;
		if (responseData) {
			getDepartmentTypesResponse = responseData.getDepartmentTypesResponse;
			if (getDepartmentTypesResponse && getDepartmentTypesResponse.errorCode === "0") {
				setDepartmentTypeValues(getDepartmentTypesResponse.departmentTypes);
			} else if (getDepartmentTypesResponse) {
				setError(t("error.error") + " " + getDepartmentTypesResponse.errorMessage);
			}
		}
	}

	const valueHandler = (e) => {
		const { name, value } = e.target;
		if(typeof value === 'undefined'){
			value="";
		}
		setFormValues({ ...formValues, [name]: value });
	}

	const countryHandler = (selectedOption, action) => {
		let countryCode = selectedOption ? selectedOption.value : "";
		let countryName = selectedOption ? selectedOption.label : "";
		formValues.countryCode = countryCode;
		setCountrySelected({ ...countrySelected, label: (countryName), value: countryCode });
		setStateValues(states, countryCode, false);
	}

	const stateHandler = (selectedOption, action) => {
		let state = selectedOption ? selectedOption.value : "";
		let stateName = selectedOption ? selectedOption.label : "";
		setStateSelected({ ...stateSelected, label: (stateName), value: state });
		if (state) {
			let stateArr = state.split("-");
			formValues.stateKey = stateArr[0];
			formValues.stateCode = stateArr[1];
		}
	}

	const timezoneHandler = (selectedOption, action) => {
		let timezoneCode = selectedOption ? selectedOption.value : "";
		let timezoneName = selectedOption ? selectedOption.label : "";
		formValues.departmentTimeZone = timezoneCode;
		setTimezoneSelected({ ...timezoneSelected, label: (timezoneName), value: timezoneCode });
	}

	const deptTypeHandler = (selectedOption, action) => {
		let deptTypeKey = selectedOption ? selectedOption.value : 0;
		let deptTypeName = selectedOption ? selectedOption.label : "";
		formValues.departmentTypeKey = deptTypeKey;
		setDepartmentTypeSelected({ ...departmentTypeSelected, label: (deptTypeName), value: deptTypeKey });
	}

	const handleSubmit = (event) => {
		event.preventDefault();
		setIsSubmit(true);
		const formData = new FormData(event.currentTarget);
		for (let entry of formData.entries()) {
			if (entry[0] == "stateKey") {
				let stateArr = entry[1].split("-");
				formValues[entry[0]] = stateArr[0];
				formValues.stateCode = stateArr[1];

			} else {
				formValues[entry[0]] = entry[1];
			}
		}


		let errors = validateFields();
		setFormErrors(errors);
		if (!errors || errors.length === 0) {
			updateDepartment();
		} else {
			setIsSubmit(false);
		}

	};
	const validateFields = () => {
		const errors = [];
		if (add) {

		}

		if (!formValues.departmentName) {
			errors.push(t("error.deptNameReqd"));
		}
		if (!formValues.departmentTypeKey || formValues.departmentTypeKey === 0) {
			errors.push(t("error.deptTypeReqd"));
		}
		if (!formValues.stateKey || formValues.stateKey === 0) {
			errors.push(t("error.stateReqd"));
		}
		return errors;
	};
	const updateDepartment = () => {
		let action = 2;
		let departmentKey = department.departmentKey;
		if (add) {
			action = 1;
			departmentKey = 0;
		}
		let serverParams = {
			source: "web",
			action: action,
			updatedById: formValues.updatedById,
			companyId: companyId,
			departmentKey: departmentKey,
			departmentTypeKey: formValues.departmentTypeKey,
			departmentName: formValues.departmentName.trim(),
			description: formValues.description.trim(),
			address1: (formValues.address1) ? formValues.address1.trim() : '',
			address2: (formValues.address2) ? formValues.address2.trim() : '',
			phone: (formValues.phone) ? formValues.phone.trim() : '',
			zipCode: (formValues.zipCode) ? formValues.zipCode.trim() : '',
			zipExt: (formValues.zipExt) ? formValues.zipExt.trim() : '',
			city: (formValues.city) ? formValues.city.trim() : '',
			stateKey: formValues.stateKey,
			stateCode: formValues.stateCode.trim(),
			countryCode: formValues.countryCode,
			departmentTimeZone: formValues.departmentTimeZone,
			latitude: (formValues.latitude) ? formValues.latitude.trim() : '',
			longitude: (formValues.longitude) ? formValues.longitude.trim() : ''

		};

		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(serverParams),
		};

		try {
			FetchUtil.fetchAPI("UpdateDepartment", "/Service/CompanyService/AddUpdateDepartment", requestOptions, updateDepartmentSuccess, updateDepartmentFail);
		} catch (error) {
			setError(error.message);
		}
	};

	function updateDepartmentFail(redirect) {
		setIsSubmit(false);
		setError(t("error.deptEditFailed"));
	}
	function updateDepartmentSuccess(responseData) {
		setIsSubmit(false);
		let addUpdateDepartmentResponse;
		if (responseData) {
			addUpdateDepartmentResponse = responseData.addUpdateDepartmentResponse;
			if (addUpdateDepartmentResponse) {
				if (addUpdateDepartmentResponse.errorCode === "0") {
					handleClose();
					refetch();
					navigate("/pages/departments");
				} else {
					setError(t("error.error") + " " +
						addUpdateDepartmentResponse.errorMessage
					);
				}
			}
		}
	}

	return (
		<>
		{(userCtx.role === "SiteAdmin" || userCtx.role === "ClientAdmin") ?
		<div className="modalContainer hide-scrollbar">
			<div className="row">
				<div className="col mt-3">
					{((formErrors && formErrors.length > 0) || error) ? (
						<div id="inerrorMessage" className="errorblock">
							{((formErrors && formErrors.length > 0)) ? (
								formErrors.map((errorData, index) => (
									<p className="message-line">{errorData}</p>
								))
							) : ""}
							{error}
						</div>
					):(<></>)}
				</div>
			</div>
			<div className="row">
				<div className="col">
					<form
						className="regn_form_container"
						acceptCharset="UTF-8"
						id="sign-up"
						onSubmit={handleSubmit}
					>
						<h2>{(add) ? t("page.dept.add") : t("page.dept.edit")}
						</h2>
						<div className="row">
							<div className="col">
								<div className="form-group">
									<label htmlFor="departmentTypeKey" className="form-label">
										<span className="form_required">*</span>
										{t("page.dept.type")}
									</label>
									<Select
										name="departmentTypeKey"
										options={departmentTypeOptions}
										onChange={deptTypeHandler}
										placeholder={""}
										value={departmentTypeSelected}
										isSearchable={true}
										isClearable={true}
										className="myselect"
										inputId="deptType-input"
										styles={ddStyles}
									/>
								</div>
							</div>
							<div className="col">
								<div className="form-group">
									<label htmlFor="departmentName" className="form-label">
										<span className="form_required">*</span>
										{t("page.dept.name")}
									</label>

									<input
										type="text"
										name="departmentName"
										id="departmentName"
										placeholder="Name"
										maxLength="50"
										value={formValues.departmentName}
										onChange={(e) => valueHandler(e)}
										className="form-control rounded-pill border-0 shadow-sm px-4"
									/>
								</div>
							</div>
						</div>
						<div className="row">
							<div className="col">
								<div className="form-group">
									<label htmlFor="description" className="form-label">
										{t("page.description")}
									</label>

									<input
										type="text"
										name="description"
										id="description"
										placeholder=""
										maxLength="100"
										value={formValues.description}
										onChange={(e) => valueHandler(e)}
										className="form-control rounded-pill border-0 shadow-sm px-4"
									/>
								</div>
							</div>
							<div className="col">
								<div className="form-group">
									<label className="form-label">
										{t("page.timezone")}
									</label>
									<Select
										name="departmentTimeZone"
										options={timezoneOptions}
										onChange={timezoneHandler}
										placeholder={""}
										value={timezoneSelected}
										isSearchable={true}
										isClearable={true}
										className="myselect"
										inputId="departmentTimeZone-input"
										styles={ddStyles}
									/>
								</div>
							</div>
						</div>
						<div className="row">
							<div className="col">
								<div className="form-group">
									<label className="form-label">
										<span className="form_required">*</span>
										{t("page.country")}
									</label>
									<Select
										name="countryCode"
										options={countryOptions}
										onChange={countryHandler}
										placeholder={defCountryText}
										value={countrySelected}
										isSearchable={true}
										isClearable={true}
										className="myselect"
										inputId="countryCode-input"
										styles={ddStyles}
									/>
								</div>
							</div>
						</div>
						<div className="row">
							<div className="col">
								<div className="form-group">
									<label className="form-label">
										{t("page.address1")}
									</label>
									<input name="address1" value={formValues.address1} maxlength="40"
										className="form-control rounded-pill border-0 shadow-sm px-4"
										onChange={(e) => valueHandler(e)} />
								</div>
							</div>
							<div className="col">
								<div className="form-group">
									<label className="form-label">
										{t("page.address2")}
									</label>
									<input name="address2" value={formValues.address2} maxlength="40"
										className="form-control rounded-pill border-0 shadow-sm px-4"
										onChange={(e) => valueHandler(e)} />
								</div>
							</div>
						</div>
						<div className="row">
							<div className="col">
								<div className="form-group">
									<label className="form-label">
										{t("page.city")}
									</label>
									<input name="city" value={formValues.city} maxlength="40"
										className="form-control rounded-pill border-0 shadow-sm px-4"
										onChange={(e) => valueHandler(e)} />
								</div>
							</div>
							<div className="col">
								<div className="form-group">
									<label className="form-label">
										<span className="form_required">*</span>
										{t("page.state")}
									</label>
									<Select
										name="stateKey"
										options={stateOptions}
										onChange={stateHandler}
										placeholder={""}
										value={stateSelected}
										isSearchable={true}
										isClearable={true}
										className="myselect"
										inputId="stateKey-input"
										styles={ddStyles}
									/>
								</div>
							</div>
						</div>
						<div className="row">
							<div className="col-xs-2 col-3">
								<div className="form-group">
									<label className="form-label">
										{t("page.zipCode")}
									</label><input name="zipCode" value={formValues.zipCode}
										maxlength="12"
										className="form-control rounded-pill border-0 shadow-sm px-4"
										onChange={(e) => valueHandler(e)} />
								</div>
							</div>
							<div className="col-xs-2 col-3">
								<div className="form-group">
									<label className="form-label">
										{t("page.zipExt")}
									</label>
									<input name="zipExt" value={formValues.zipExt}
										maxlength="4"
										className="form-control rounded-pill border-0 shadow-sm px-4"
										onChange={(e) => valueHandler(e)} />
								</div>
							</div>
							<div className="col">
								<div className="form-group">
									<label className="form-label">
										{t("page.phone")}
									</label>
									<input name="phone" value={formValues.phone}
										maxlength="15" className="form-control rounded-pill border-0 shadow-sm px-4"
										onChange={(e) => valueHandler(e)} />
								</div>
							</div>
						</div>
						<div className="row">
							<div className="col">
								<div className="form-group">
									<label className="form-label">
										{t("page.latitude")}
									</label><input name="latitude" value={formValues.latitude}
										maxlength="13"
										className="form-control rounded-pill border-0 shadow-sm px-4"
										onChange={(e) => valueHandler(e)} />
								</div>
							</div>
							<div className="col">
								<div className="form-group">
									<label className="form-label">
										{t("page.longitude")}
									</label>
									<input name="longitude" value={formValues.longitude}
										maxlength="13"
										className="form-control rounded-pill border-0 shadow-sm px-4"
										onChange={(e) => valueHandler(e)} />
								</div>
							</div>
						</div>
						<div className="footer">
							<input
								type="button"
								name="edit-dept-close"
								id="edit-dept-close"
								className="btn btn-secondary btn-block" data-dismiss="modal"
								disabled={isSubmit}
								onClick={(e) => handleClose(e)}
								style={{ marginRight: "50px" }}
								value={closeText}
							></input>

							<div id="submit-spinner"
								className={isSubmit ? "spinner-border spinner-border-sm text-dark spinner-size" : "spinner-hide"}
							>  </div>
							<input
								type="submit"
								name="edit-submit"
								id="edit-submit"
								data-dismiss="modal"
								className={"btn btn-primary btn-block"}
								style={{ marginTop: "10px", marginBottom: "10px" }}
								value={submitText}
								disabled={isSubmit}
							>
							</input>

						</div>
					</form>
				</div>
			</div>
			<div className="row">
				<div className="col mt-3">
					{((formErrors && formErrors.length > 0) || error) ? (
						<div id="berrorMessage" className="errorblock">
							{((formErrors && formErrors.length > 0)) ? (
								formErrors.map((errorData, index) => (
									<p className="message-line">{errorData}</p>
								))
							) : ""}
							{error}
						</div>
					):(<></>)}
				</div>
			</div>
			<div className="row">
				<div className="col">
					<div id="placeholder_1" className="placeholder-pg" style={{ height: "10px" }}></div>
				</div>
			</div>
		</div>
		: null}
	    </>
	);
}

export default DepartmentModal;